var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-play';
                    var viewUrl = 'sprite.svg#view-icon-play';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-play#icon-play';
                            viewUrl = 'sprite.svg?icon-play#view-icon-play';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 247.506 247.506',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };